import React from "react";
import {
  onLanguageChange,
  onTranslationChange,
  parseNamespaceAndKey,
  resolveTranslation,
  TranslateContext,
  translateSync,
} from "..";

/**
 * Custom hook to handle translations and re-render on language or translation changes.
 *
 * Use like this:
 *
 * const t = useTranslation();
 *
 * t("key");
 *
 * @returns A function that takes a translation key or keys and an optional context, and returns the translated string.
 */
export function useTranslation(): (
  input: string | string[],
  contextOrDefault?: string | TranslateContext
) => string {
  const [state, setState] = React.useState(0);
  const nsInUseRef = React.useRef(new Set<string>());

  React.useEffect(() => {
    return onTranslationChange((namespace) => {
      // if (nsInUseRef.current.has(namespace)) {
      // trigger a render by setting a state
      setState((x) => x + 1);
      // }
    });
  }, []);

  React.useEffect(() => {
    return onLanguageChange((lang) => {
      // trigger a render by setting a state
      setState((x) => x + 1);
    });
  }, []);

  return function translateSyncReact(
    input: string | string[],
    contextOrDefault?: string | TranslateContext
  ) {
    const ids = parseNamespaceAndKey(input);

    for (const [namespace] of ids) {
      if (namespace && !nsInUseRef.current.has(namespace)) {
        nsInUseRef.current.add(namespace);

        resolveTranslation(namespace);
      }
    }

    return translateSync(input, contextOrDefault);
  };
}
